import clsx from "clsx"
import { FC } from "react"
import { Modal } from "@/ui/Modal"
import styles from "./FlexStoneExample.module.scss"

const modalType = "flexStoneExample"

export const FlexStoneExample: FC = () => {
  return (
    <Modal.Center type={modalType} className={clsx(styles.FlexStoneExample)}>
      <Modal.StoneFlexContainer>
        <div className={clsx(styles.FlexStoneExample)}>
          <textarea style={{ resize: "both" }}></textarea>
        </div>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
